import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./i9n_sync_scope.js";
//#region src/i9n_sync_scope_helper.ts
var i9n_sync_scope_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(syncScope) {
	switch (syncScope) {
		case "availability-only": return "Availability Only";
		case "full-sync": return "Full Sync";
	}
}
//#endregion
export { i9n_sync_scope_helper_exports, name };

//# sourceMappingURL=i9n_sync_scope_helper.js.map